import React, { Component, SyntheticEvent } from "react";
import classNames from "classnames";
import { Route, Switch, withRouter, RouteComponentProps } from "react-router-dom";
import { ScrollPanel } from 'primereact/scrollpanel';
import { MenuItem } from "primereact/MenuItem";
import { BreadCrumb } from 'primereact/breadcrumb';
import { createBrowserHistory } from "history";
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import 'bootstrap/dist/css/bootstrap.min.css';
// import { AppnewMenu } from "./Appnewmenu";
import { getCurrentUser } from "../src/store/selectors/Accounts";
import { AppMenu } from "./AppMenu";
import InputPermissionData from "./assets/data/InputPermissionData.json";
import InputAttorneyPermissionData from "./assets/data/InputAttorneyPermissionData.json";
import "./layout/layout.css";
import "./App.css";
import "./New_CSS/Paginator.css";
import "./New_CSS/DataTableRows.css";
import "./New_CSS/PageFooter.css";
import "./New_CSS/MobileDialogs.css";
import "./New_CSS/CaseDialogs.css";
import "./New_CSS/CaseCommon.css";
import "./New_CSS/TabViewOverflow.css";
import "./New_CSS/AppTheme.css";
import "./New_CSS/ListPage.css";
import "./New_CSS/CasePage.css";
import * as Constants from "../src/containers/pages/Constants/ConstantValues";
import { } from "./containers/pages";
import { Dialog } from "primereact/dialog";
import { AppLeftMenu } from "./AppLeftMenu";
import { AppTopbar } from "./AppTopbar";
import { AppnewMenu } from "./Appnewmenu";
import { ToastContainer } from "react-toastify";

const LoginPage = React.lazy(() => import('./containers/pages/Login/Login'));
const Welcome = React.lazy(() => import('./containers/pages/Welcome'));
const CreateEmployer = React.lazy(() => import('./containers/pages/New_Visacare/CreateEmployer'));
const FirstLoginChangePassword = React.lazy(() => import('./containers/pages/Login/FirstLoginChangePassword'));
const AddLawFirm = React.lazy(() => import('./containers/pages/LawFirm/AddLawFirm'));
const ForgotPasswordUpdate = React.lazy(() => import('./containers/pages/ForgotPasswordUpdate'));
const ResetpasswordPage = React.lazy(() => import('./containers/pages/Resetpassword'));
const PasswordchangePage = React.lazy(() => import('./containers/pages/Forgotpassword'));
const ForgotusernamePage = React.lazy(() => import('./containers/pages/Forgotusername'));
const CheckingPage = React.lazy(() => import('./containers/pages/Checksession'));
const UscisCallback = React.lazy(() => import('./containers/pages/UscisCallback'));

const AddNewI129Upcomming = React.lazy(() => import('./containers/pages/Visacare/AddCaseI129Upcomming'));

const AddNewI129 = React.lazy(() => import('./containers/pages/Visacare/AddCaseI129'));
const AddCaseI140 = React.lazy(() => import('./containers/pages/Visacare/AddCaseI140'));
const AddNewCaseI539 = React.lazy(() => import('./containers/pages/Visacare/AddCaseI539New'));
const AddNewCaseI539A = React.lazy(() => import('./containers/pages/Visacare/AddCaseI539ANew'));

const AddCaseI539 = React.lazy(() => import('./containers/pages/Visacare/AddCaseI539'));
const AddCaseI539A = React.lazy(() => import('./containers/pages/Visacare/AddCaseI539A'));

const AddCaseH1BI907 = React.lazy(() => import('./containers/pages/Visacare/AddCaseH1BI907'));

const AddCaseG28 = React.lazy(() => import('./containers/pages/Visacare/AddCaseG28'));
const AddNewCaseI765 = React.lazy(() => import('./containers/pages/Visacare/AddCaseI765'));

const AddCaseI130 = React.lazy(() => import('./containers/pages/Visacare/AddCaseI130'));
const AddCaseI130A = React.lazy(() => import('./containers/pages/Visacare/AddCaseI130A'));
const AddCaseI131 = React.lazy(() => import('./containers/pages/Visacare/AddCaseI131'));

const AddCaseI485 = React.lazy(() => import('./containers/pages/Visacare/AddCaseI485'));
const AddCaseI864 = React.lazy(() => import('./containers/pages/Visacare/AddCaseI864'));

const WopiTest = React.lazy(() => import('./containers/pages/Wopi/WopiTest'));
const WopiEditTest = React.lazy(() => import('./containers/pages/Wopi/WopiEditTest'));

const WopiH1BRevocation = React.lazy(() => import('./containers/pages/Wopi/WopiH1BRevocation'));
const WopiPublicAccessFile = React.lazy(() => import('./containers/pages/Wopi/WopiPublicAccessFile'));
const WopiWithdrawal = React.lazy(() => import('./containers/pages/Wopi/WopiWithdrawal'));
const WopiVisaPackage = React.lazy(() => import('./containers/pages/Wopi/WopiVisaPackage'));
const WopiCoveringLetter = React.lazy(() => import('./containers/pages/Wopi/WopiCoveringLetter'));
const WopiWordFile = React.lazy(() => import('./containers/pages/Wopi/WopiWordFile'));
const WopiOfferLetter = React.lazy(() => import('./containers/pages/Wopi/WopiOfferLetter'));
const WopiDocumentFile = React.lazy(() => import('./containers/pages/New_Document_Forms/WopiDocumentFile'));
const DocuSignViewPage = React.lazy(() => import('./containers/pages/DocuSign/DocuSignViewPage'));


const StaticPage = React.lazy(() => import('./containers/pages/Visacare/StaticPage'));
const VisaCareEmployerList = React.lazy(() => import('./containers/pages/Visacare/VisaCareEmployerList'));
const LawFirmDashboard = React.lazy(() => import('./containers/pages/LawFirm/LawFirmDashboard'));
const LawFirmSetUp = React.lazy(() => import('./containers/pages/LawFirm/LawFirmSetUp'));
const LawFirmAddAttorney = React.lazy(() => import('./containers/pages/LawFirm/LawFirmAddAttorney'));
const LawFirmManageCorporateClient = React.lazy(() => import('./containers/pages/LawFirm/LawFirmManageCorporateClient'));
const LawFirmManageCorporateCases = React.lazy(() => import('./containers/pages/LawFirm/LawFirmManageCorporateCases'));
const LawFirmManageCorporateUser = React.lazy(() => import('./containers/pages/LawFirm/LawFirmManageCorporateUser'));
const LawFirmCorporateSetup = React.lazy(() => import('./containers/pages/LawFirm/LawFirmCorporateSetup'));
const LawFirmAttorneySetUp = React.lazy(() => import('./containers/pages/LawFirm/LawFirmAttorneySetUp'));
const LawFirmH1BAddCaseI129 = React.lazy(() => import('./containers/pages/LawFirm/LawFirmH1BAddCaseI129'));
const LawFirmH1BCaseDetails = React.lazy(() => import('./containers/pages/LawFirm/LawFirmH1BCaseDetails'));
const LawFirmH1BQuestionnaier = React.lazy(() => import('./containers/pages/LawFirm/LawFirmH1BQuestionnaier'));
const LawFirmFullCalendarTask = React.lazy(() => import('./containers/pages/LawFirm/LawFirmFullCalendarTask'));

const LawFirmCompanyUserCasePermission = React.lazy(() => import('./containers/pages/LawFirm/LawFirmCompanyUserCasePermission'));

const AttorneySetUp = React.lazy(() => import('./containers/pages/Visacare/AttorneySetUp'));
const EmployerProfile = React.lazy(() => import('./containers/pages/New_Visacare/EmployerProfile'));
const AddCorporate = React.lazy(() => import('./containers/pages/Visacare/AddCorporate'));
const NewUser = React.lazy(() => import('./containers/pages/NewUser'));
const CreateUser = React.lazy(() => import('./containers/pages/New_Visacare/CreateUser'));
const Users = React.lazy(() => import('./containers/pages/New_Visacare/Users'));
const setPassword = React.lazy(() => import('./containers/pages/Login/Changingpassword'));
const Permissions = React.lazy(() => import('./containers/pages/StaticUI/Permissions'));
const Roles = React.lazy(() => import('./containers/pages/StaticUI/Roles'));
const Aarolespermission = React.lazy(() => import('./containers/pages/AdminStatic/Aarolespermission'));
const Newaarolespermission = React.lazy(() => import('./containers/pages/AdminStatic/Newaarolespermission'));
const RolePermissionMap = React.lazy(() => import('./containers/pages/AdminStatic/RolePermissionMap'));
const Aaroles = React.lazy(() => import('./containers/pages/AdminStatic/Aaroles'));
const Aapermissions = React.lazy(() => import('./containers/pages/AdminStatic/Aapermissions'));
const Permission = React.lazy(() => import('./containers/pages/AdminStatic/Permissions'));
const Role = React.lazy(() => import('./containers/pages/AdminStatic/Role'));
const VisaCareDashboard = React.lazy(() => import('./containers/pages/New_Visacare/DashBoard'));
const VisaCareManageUsers = React.lazy(() => import('./containers/pages/New_Visacare/Manageuser'));
const VisaCareManageClients = React.lazy(() => import('./containers/pages/Visacare/ManageClients'));
const VisaCareManageCases = React.lazy(() => import('./containers/pages/New_Visacare/ManageCases'));
const ManageAttorneyHelpCases = React.lazy(() => import('./containers/pages/Visacare/ManageAttorneyHelpCases'));
const ManageOrderCases = React.lazy(() => import('./containers/pages/New_Visacare/ManageOrderCases'));
const AddNewAttorney = React.lazy(() => import('./containers/pages/New_Attorney/AddAttorney'));
const VisaCareManageAttorneys = React.lazy(() => import('./containers/pages/Visacare/ManageAttorney'));
const AddNewCorporate = React.lazy(() => import('./containers/pages/Visacare/AddCorporateSetup'));
const AddCaseI129HClassification = React.lazy(() => import('./containers/pages/Visacare/AddCaseI129HClassification'));
const AddCaseI129H1BDataCollection = React.lazy(() => import('./containers/pages/Visacare/AddCaseI129H1BDataCollection'));
const CreateCase = React.lazy(() => import('./containers/pages/Visacare/CreateCase'));
const H1BCaseDetails = React.lazy(() => import('./containers/pages/New_Employer_Case_Details/H1BCaseDetails'));
const I130CaseDetails = React.lazy(() => import('./containers/pages/New_Employer_Case_Details/I130CaseDetails'));
const I131CaseDetails = React.lazy(() => import('./containers/pages/New_Employer_Case_Details/I131CaseDetails'));
const I864CaseDetails = React.lazy(() => import('./containers/pages/New_Employer_Case_Details/I864CaseDetails'));
const I485CaseDetails = React.lazy(() => import('./containers/pages/New_Employer_Case_Details/I485CaseDetails'));


const H1BEmployeeNewCaseDetails = React.lazy(() => import('./containers/pages/New_Employee_Case_Details/H1BEmployeeNewCaseDetails'));
const H1BQuestionnaier = React.lazy(() => import('./containers/pages/New_Employer_Case_Details/H1BQuestionnaier'));
const AddPAFFile = React.lazy(() => import('./containers/pages/Visacare/AddPAFFile'));
const Upload = React.lazy(() => import('./containers/pages/Visacare/upload'));


const PAFCaseDetails = React.lazy(() => import('./containers/pages/New_Employer_Case_Details/PAFCaseDetailsOnly'));

const H4CaseDetails = React.lazy(() => import('./containers/pages/New_Employer_Case_Details/H4CaseDetails'));
const H4Questionnaier = React.lazy(() => import('./containers/pages/Visacare/H4Questionnaier'));
const I140CaseDetails = React.lazy(() => import('./containers/pages/New_Employer_Case_Details/I140CaseDetails'));
const I140Questionnaier = React.lazy(() => import('./containers/pages/New_Employer_Case_Details/I140PetitionerQuestionnaire'));
const FLCCaseDetails = React.lazy(() => import('./containers/pages/New_Employer_Case_Details/LCACaseDetailsOnly'));
const FLCQuestionnaier = React.lazy(() => import('./containers/pages/Visacare/FLCQuestionnaier'));
const TNPetitionQuestionnaier = React.lazy(() => import('./containers/pages/Visacare/TNPetitionQuestionnaier'));
const TNPetitionDetails = React.lazy(() => import('./containers/pages/Visacare/TNPetitionDetails'));
const E3AustralianDetails = React.lazy(() => import('./containers/pages/Visacare/E3AustralianDetails'));
const E3AustralianQuestionnaier = React.lazy(() => import('./containers/pages/Visacare/E3AustralianQuestionnaier'));
const EADApplicationDetails = React.lazy(() => import('./containers/pages/Visacare/EADApplicationDetails'));
const EADQuestionnaier = React.lazy(() => import('./containers/pages/Visacare/EADQuestionnaier'));
const H1B1Questionnaier = React.lazy(() => import('./containers/pages/Visacare/H1B1Questionnaier'));
const H1B1CaseDetails = React.lazy(() => import('./containers/pages/Visacare/H1B1CaseDetails'));
const FileUploadView = React.lazy(() => import('./containers/pages/Visacare/FileUploadView'));
const CompanySubscription = React.lazy(() => import('./containers/pages/Visacare/CompanySubscription'));

const SessionExpire = React.lazy(() => import('./containers/pages/SessionExpire'));

const TermsAndConditions = React.lazy(() => import('./containers/pages/StripePayment/TermsAndConditions'));
const Frequency = React.lazy(() => import('./containers/pages/StripePayment/Frequency'));
const Subscription = React.lazy(() => import('./containers/pages/StripePayment/Subscription'));
const TransactionDetails = React.lazy(() => import('./containers/pages/StripePayment/TransactionDetails'));
const VmCompanyDiscountMapping = React.lazy(() => import('./containers/pages/StripePayment/VmCompanyDiscountMapping'));
const SubscriptionFrequencyMap = React.lazy(() => import('./containers/pages/StripePayment/SubscriptionFrequencyMap'));
const SubscriptionFrequencyEmployerView = React.lazy(() => import('./containers/pages/New_StripePayment/SubscriptionFreqEmpView'));
const AddPaymentMethod = React.lazy(() => import('./containers/pages/New_StripePayment/VisacareAddPaymentMethod'));
const LawfirmList = React.lazy(() => import('./containers/pages/LawFirm/LawFirmList'));
const LawFirmAttorneyDashboard = React.lazy(() => import('./containers/pages/LawFirm/LawFirmAttorneyDashboard'));
const LawFirmAddCorporate = React.lazy(() => import('./containers/pages/LawFirm/LawFirmAddCorporate'));
const StatusReport = React.lazy(() => import('./containers/pages/New_Reports/StatusReport'));
const H1BExpirationDateReports = React.lazy(() => import('./containers/pages/New_Reports/H1BExpirationDateReports'));
const CaseStatusReport = React.lazy(() => import('./containers/pages/New_Reports/CaseStatusReport'));
const TrackingStatusReport = React.lazy(() => import('./containers/pages/New_Reports/TrackingStatusReport'));
const InvoiceDetails = React.lazy(() => import('./containers/pages/New_Reports/InvoiceDetails'));
const SearchReportPage = React.lazy(() => import('./containers/pages/New_Reports/SearchReportPage'));


const EmployeeStatusReports = React.lazy(() => import('./containers/pages/New_Reports/EmployeeStatusReports'));
const H4EmployeeNewCaseDetails = React.lazy(() => import('./containers/pages/New_Employee_Case_Details/H4EmployeeNewCaseDetails'));
const I765EmployeeNewCaseDetails = React.lazy(() => import('./containers/pages/New_Employee_Case_Details/EADEmployeeNewCaseDetails'));
const CasesRFEStatus = React.lazy(() => import('./containers/pages/New_Visacare/CasesRFEStatus'));
const NewUserCreate = React.lazy(() => import('./containers/pages/Visacare/NewUserCreate'));
const AddUpcomingEvents = React.lazy(() => import('./containers/pages/New_Reports/AddUpcomingEvents'));
const I765CaseDetails = React.lazy(() => import('./containers/pages/New_Employer_Case_Details/EADCaseDetails'));
const EmploymentInfo = React.lazy(() => import('./containers/pages/New_Visacare/EmployeeInformation'));
const EmployeeMyCases = React.lazy(() => import('./containers/pages/New_Employee/EmployeeMyCases'));
const AttorneyCaseDetails = React.lazy(() => import('./containers/pages/New_Attorney/AttorneyCaseDetails'));
const AttorneyDashboard = React.lazy(() => import('./containers/pages/New_Attorney/AttorneyDashboard'));
const AttorneyUserPage = React.lazy(() => import('./containers/pages/New_Attorney/AttorneyUser'));

const SendEmailDetails = React.lazy(() => import('./containers/pages/New_Reports/SendEmailDetails'));
const ReportPageViewPageView = React.lazy(() => import('./containers/pages/New_Reports/ReportPageViewPageView'));
const VisaBulletin = React.lazy(() => import('./containers/pages/New_Reports/VisaBulletin'));
const VisacareNews = React.lazy(() => import('./containers/pages/Home/VisacareNews'));
const AttorneyHelpDeskMyCases = React.lazy(() => import('./containers/pages/New_Attorney/AttorneyHelpDeskMyCases'));
const DocumentCaseDetails = React.lazy(() => import('./containers/pages/New_Document_Forms/DocumentCaseDetails'));
const DocumentH4CaseDetails = React.lazy(() => import('./containers/pages/New_Document_Forms/DocumentH4CaseDetails'));
const DocumentEADCaseDetails = React.lazy(() => import('./containers/pages/New_Document_Forms/DocumentEADCaseDetails'));
const DocumentI140CaseDetails = React.lazy(() => import('./containers/pages/New_Document_Forms/DocumentI140CaseDetails'));
const DocumentI485CaseDetails = React.lazy(() => import('./containers/pages/New_Document_Forms/DocumentI485CaseDetails'));
const DocumentI94CaseDetails = React.lazy(() => import('./containers/pages/New_Document_Forms/DocumentI94CaseDetails'));
const DocumentPermCaseDetails = React.lazy(() => import('./containers/pages/New_Document_Forms/DocumentPermCaseDetails'));
const DocumentLCAPAFCaseDetails = React.lazy(() => import('./containers/pages/New_Document_Forms/DocumentLCAPAFCaseDetails'));

const AddLCARequestDetails = React.lazy(() => import('./containers/pages/New_Employer/AddLCARequestDetails'));
const LcaRequestDetails = React.lazy(() => import('./containers/pages/New_Employer/LcaRequestDetails'));
const PublicAccessFiles = React.lazy(() => import('./containers/pages/New_Employer/PublicAccessFiles'));

const Createi9 = React.lazy(() => import('./containers/pages/New_Employer_Case_Details/Createi9'));
const I9SearchDetails = React.lazy(() => import('./containers/pages/New_Employer_Case_Details/I9SearchDetails'));
const AddCaseI9 = React.lazy(() => import('./containers/pages/New_Employer_Case_Details/AddCaseI9'));
const I9Dashbord = React.lazy(() => import('./containers/pages/New_Employer_Case_Details/I9Dashbord'));
const AddI9Section1 = React.lazy(() => import('./containers/pages/New_Employer_Case_Details/AddI9Section1'));
const PermCaseData = React.lazy(() => import('./containers/pages/New_Perm_Application/PermCaseData'));


const I130ACaseDetails = React.lazy(() => import('./containers/pages/New_Employer_Case_Details/I130ACaseDetails'));
const I130BeneficiaryQuestionnaire = React.lazy(() => import('./containers/pages/New_Employer_Case_Details/I130BeneficiaryQuestionnaire'));
const I130PetitionerQusetionnaire = React.lazy(() => import('./containers/pages/New_Employer_Case_Details/I130PetitionerQuestionnaire'));
const I131PetitionerQusetionnaire = React.lazy(() => import('./containers/pages/New_Employer_Case_Details/I131PetitionerQuestionnaire'));
const I864Qusetionnaire = React.lazy(() => import('./containers/pages/New_Employer_Case_Details/I864Questionnaire'));

const I485Qusetionnaire = React.lazy(() => import('./containers/pages/New_Employer_Case_Details/I485Questionnaire'));

const EmailPages = React.lazy(() => import('./containers/pages/Email/EmailViewer/EmailPages'));
const ChatAI = React.lazy(() => import('./containers/pages/OpenAI/ChatAI'));
const ChatWithAi = React.lazy(() => import('./containers/pages/Login/Dialogpage'));

const DeleteCaseData = React.lazy(() => import("./containers/pages/Login/DeleteCaseData"));
const DeleteCaseDatanew = React.lazy(() => import("./containers/pages/Login/DeleteCaseDatanew"));

const iPAddress = Constants.IpAddress;

interface IAppState {
    timeout: number,
    showModal: boolean,
    addOpenDialog: boolean
    userLoggedIn: boolean,
    isTimedOut: boolean,
    isloading: boolean,
    staticMenuInactive: boolean,
    overlayMenuActive: boolean,
    mobileMenuActive: boolean,
    isLogged: boolean,
    iconmenuActive: boolean,
    layoutMode: string,
    layoutColorMode: string,
    UserDisplayName: string,
    role: [],
    rolebyid: [],
    rolepermission: [],
    isOnline: any;
    roleid: string,
    isSkipHeader: boolean,
    Aaroles: string;
}
interface timelineDetails {
    label: string
}
interface Props extends RouteComponentProps { }
class NewApp extends Component<Props, IAppState> {

    private menuClick: boolean = false;
    private layoutMenuScroller!: ScrollPanel | null;
    private menu!: Array<MenuItem>;
    private breadcrumDetails: timelineDetails[] = [

    ];

    private home = { icon: 'pi pi-home', url: 'https://www.primefaces.org/primereact/showcase' }
    history = createBrowserHistory();

    public idleTimer;
    public iPAddress = Constants.IpAddress;
    public selectedCorporateId = window.localStorage.getItem("selectedCorporateId");
    public rolespermissionList = null;
    public constructor(props: any) {
        super(props);
        this.state = {
            isLogged: false,
            timeout: 1000 * 20 * 60,
            showModal: false,
            addOpenDialog: false,
            userLoggedIn: false,
            isloading: true,
            isTimedOut: false,
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false,
            iconmenuActive: true,
            layoutMode: "static",
            layoutColorMode: "dark",
            role: [],
            UserDisplayName: "",
            isOnline: navigator.onLine,
            rolepermission: [],
            rolebyid: [],
            isSkipHeader: false,
            Aaroles: "",
            roleid: ""
        }
        this.onWrapperClick = this.onWrapperClick.bind(this);
        this.onToggleMenu = this.onToggleMenu.bind(this);
        this.onSidebarClick = this.onSidebarClick.bind(this);
        this.onMenuItemClick = this.onMenuItemClick.bind(this);
        // this.componentWillMount();
        //   const TokenString = localStorage.getItem("TOKENAUTH");
        console.log(" App " + new Date());
        // window.addEventListener('beforeunload', this.listener);



        this.idleTimer = null
        this._onAction = this._onAction.bind(this)
        this._onActive = this._onActive.bind(this)
        this._onIdle = this._onIdle.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleLogout = this.handleLogout.bind(this)
        this._onpush = this._onpush.bind(this)
        this._onnopush = this._onnopush.bind(this)
        this.handleInternetCheck = this.handleInternetCheck.bind(this);
    }

    _onAction(e) {

        this.setState({ isTimedOut: false })
    }
    _onpush(e) {

        this.setState({ iconmenuActive: true })
    }
    _onnopush(e) {

        this.setState({ iconmenuActive: false })
    }
    _onActive(e) {

        this.setState({ isTimedOut: false })
    }

    _onIdle(e) {

        const isTimedOut = this.state.isTimedOut
        var currentUser = getCurrentUser();

        if (currentUser !== null && currentUser !== "") {
            if (isTimedOut) {

            } else {
                this.setState({ showModal: true })
                this.idleTimer.reset();
                this.setState({ isTimedOut: true })
            }
        }

    }
    handleClose() {
        this.setState({ showModal: false })
        this.setState({
            addOpenDialog: false,
        });
    }


    /*
      listener(e: BeforeUnloadEvent) {
    
        e.preventDefault();
    
        return "Test";
      }*/

    handleLogout() {
        const loggedInString = localStorage.getItem("AUTHDATA");
        if (loggedInString) {
            const loggedInData = JSON.parse(loggedInString);
            //alert(JSON.stringify(loggedInData.loginhistory.userId));
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer my-token',
                    'My-Custom-Header': 'foobar'
                },
                body: JSON.stringify({ userId: loggedInData.userProfile[0].userautoid.userId })
            };

            fetch(iPAddress + '/api2/api/logout', requestOptions)
                .then(response => response.json())
                .then(json => {

                })
        }
        this.setState({ showModal: false })
        this.selectedCorporateId = "";
        window.localStorage.setItem("AUTHDATA", "");
        window.localStorage.setItem("selectedCorporateId", "");
        window.localStorage.setItem("loggedCorporateId", "");
        window.localStorage.setItem("selectedLawfirmId", "");
        window.localStorage.setItem("loggedLawfirmId", "");
        window.localStorage.setItem("selectedAttorneyId", "");
        window.localStorage.setItem("loggedAttorneyId", "");
        window.localStorage.setItem("AUTHDATA", "");
        window.localStorage.setItem("LOGINLAWFIRMDATA", null);
        window.location.href = "/login";
    }

    createReportUserMenu() {
        this.menu = [
            {
                label: "Reports",
                icon: "pi pi-fw pi-file",
                items: [
                    {
                        label: "Reports",
                        icon: "pi pi-fw pi-file",
                        command: () => {
                            this.props.history.push("/reports");
                        }
                    }
                ]
            }
        ];
    }

    createnewUserMenu() {
        var o = {};

        if ((window.location.pathname === '/vCareLawFirmDashboard' || window.location.pathname === '/visaCareCreateEmployer' || window.location.pathname === '/visaCareAttorneyDashboard')) {

            window.localStorage.setItem("selectedCorporateId", "");
            this.selectedCorporateId = "";

        }

        if (this.selectedCorporateId !== null && this.selectedCorporateId !== "" && this.selectedCorporateId.length > 0) {

            var obj = JSON.parse(window.localStorage.getItem("employerRolePermission"));
            var res = [];
            for (var ij in obj)
                res.push(obj[ij]);

            let loggedInString1 = localStorage.getItem("AUTHDATA");
            const loggedInData = JSON.parse(loggedInString1);

            if (loggedInData.userProfile[0].roleFkId.roleName === Constants.VISACAREADMINROLENAME) {
                this.rolespermissionList = InputPermissionData;
            } else {
                this.rolespermissionList = InputAttorneyPermissionData;
            }

            // this.rolespermissionList = InputPermissionData;
            if (this.rolespermissionList !== null) {
                this.rolespermissionList.sort(function (a, b) {
                    return parseInt(a.position) - parseInt(b.position);
                });
            }



        } else {

            const loggedInString = localStorage.getItem("AUTHDATA");
            if (loggedInString) {

                this.rolespermissionList = JSON.parse(loggedInString);

                this.rolespermissionList.rolespermission.sort(function (a, b) {
                    return parseInt(a.position) - parseInt(b.position);
                });
                this.rolespermissionList = this.rolespermissionList.rolespermission;

            }
        }


        let loggedInString;
        loggedInString = localStorage.getItem("AUTHDATA");
        if (loggedInString) {

            var program = new Array<any>();
            var meters = new Array<any>();


            // if((loggedInData.userProfile[0].roleFkId.roleName==="ProviderAdmin" && (window.location.pathname==="/visacareEmployerList" || window.location.pathname==="/visaCareCreateEmployer"   || window.location.pathname==="/lawFirmsDetails" )) || (loggedInData.userProfile[0].roleFkId.roleName!=="ProviderAdmin"))
            // { 

            if (this.rolespermissionList !== null && this.rolespermissionList.length > 0) {

                var count = 0;
                var start = false;

                for (var i = 0; i < this.rolespermissionList.length; i++) {


                    var element = this.rolespermissionList[i];

                    for (var j = 0; j < meters.length; j++) {
                        if (element.permission_id === meters[j].permission_id) {


                            start = true;

                        }
                    }
                    count++;
                    if (count === 1 && start === false) {
                        var name = element.description;
                        var link = element.permission_name;
                        var position = element.position;

                        const newfunct = "/" + link;

                        if (element.permission_name === "" || element.permission_name === null) {
                            const zoom =
                            {
                                id: element.permission_id,
                                label: name,
                                icon: element.icon,
                                parentId: element.parent_permission_id,
                                position: position
                            };
                            program.push(zoom);
                            meters.push(element);
                        }
                        else if (newfunct.includes("Dashboard") || newfunct.includes("H1BCaseDetails") || newfunct.includes("H4CaseDetails") || newfunct.includes("I765CaseDetails")) {
                            const zoom =
                            {
                                id: element.permission_id,
                                label: name,
                                icon: element.icon,

                                command: () => {

                                    window.location.href = newfunct;

                                },
                                parentId: element.parent_permission_id,
                                position: position
                            };
                            program.push(zoom);
                            meters.push(element);
                        } else {

                            const zoom =
                            {
                                id: element.permission_id,
                                label: name,
                                icon: element.icon,

                                command: () => {
                                    window.location.href = newfunct;
                                    // this.props.history.push(newfunct);
                                },
                                parentId: element.parent_permission_id,
                                position: position
                            };
                            program.push(zoom);
                            meters.push(element);
                        }


                    }
                    start = false;
                    count = 0;
                }
            }/*else{
        this.createnewUserMenu();
      }*/
            /*  }else{
              let selectedCorporateId=window.localStorage.getItem("selectedEnCriptedCorporateId");
         
              let zoom = {
               id: 18617,
               label: 'Home',
               icon: 'home',
               parentId: 0,
               position: 1,    
               command: () => {
                 window.location.href = '/visacareEmployerList';
               }    
             };
             program.push(zoom);
                 zoom = {
                 id: 18617, 
                 label: 'Dashboard',
                 icon: 'dashboard',
                 parentId: 0,
                 position: 1,    
                 command: () => {
                   window.location.href = '/vCareDashboard/'+selectedCorporateId;
                 }    
               };
               program.push(zoom);
               zoom = {
                 id: 18619,
                 label: "Employer Setup",
                 position: 22,     
                 icon: "userEdit",
                 parentId: 0,    
                 command: () => {
                   window.location.href = '/visaCareAddNewCorporate/'+selectedCorporateId;
                   
                 }
               };
            
             program.push(zoom);
               zoom ={
                 id: 18620,
                 label: "Manage User",
                 position: 23,     
                 icon: "userManage",
                 parentId: 0,    
                 command: () => {
                   window.location.href = '/vCareManageUser/'+selectedCorporateId;
                 }
               };
         
               program.push(zoom);
             //  meters.push(element);
             }
             */
            const zoom1 = {
                id: 1,
                label: "Reports",
                position: 24,
                icon: "reports",
                parentId: 0,
                command: () => {
                    window.localStorage.getItem("selectedEnCriptedCorporateId");
                    this.props.history.push('/visaCareReportPageView');
                    //   window.location.href = '/visaCareReportPageView';
                }
            };
            const loggedInParsed = JSON.parse(loggedInString);
            // console.log(loggedInParsed?.userProfile);
            // console.log((program));
            // console.log((loggedInParsed));
            // console.log((Constants.employeeRoleName));
            if (loggedInParsed?.userProfile[0]?.roleFkId?.roleName !== Constants.employeeRoleName) {
                program.push(zoom1);
            }

            const zoom = {
                id: 1,
                label: "Setting",
                position: 23,
                icon: "setting",
                parentId: 0,
                command: () => {
                    this.props.history.push('/staticui/setpassword');
                    //    window.location.href = '/staticui/setpassword';
                }
            };

            program.push(zoom);

            var tree = function (program, root) {

                program.forEach(function (a) {
                    try {
                        a.items = o[a.id] && o[a.id].items;
                        o[a.id] = a;
                        o[a.parentId] = o[a.parentId] || {};
                        o[a.parentId].items = o[a.parentId].items || [];
                        o[a.parentId].items.push(a);
                    } catch (exception) {
                        console.log("Error " + exception);
                    }
                });
                return o[root].items;
            }(program, '0');
            this.menu = tree;

        }
    }
    componentWillMount() {
        try {

            const loggedInData = JSON.parse(localStorage.getItem("TOKENAUTH"));


            var currentUser = getCurrentUser();

            if (currentUser !== null) {
                if (currentUser.userProfile !== null) {
                    this.setState({ UserDisplayName: (currentUser.userProfile[0].first_name + " " + currentUser.userProfile[0].last_name + " " + loggedInData.expiresIn) });
                }
            }
            const loggedInString = localStorage.getItem("AUTHDATA");
            const tokenvalue = localStorage.getItem("Token");

            if (loggedInString) {

                const loggedInData = JSON.parse(loggedInString);
                this.setState({ isLogged: loggedInData.loggedStatus === 1 });

                if (loggedInData.userProfile.length > 0) {
                    for (var i = 0; i < loggedInData.userProfile.length; i++) {

                        var role = loggedInData.userProfile[i].roleFkId.roleName;
                        //    var file = loggedInData.userProfile[i].roleFkId.roleId;
                        var devop = parseInt(loggedInData.userProfile[i].roleFkId.roleId);
                        if (this.selectedCorporateId !== null && this.selectedCorporateId !== "" && this.selectedCorporateId.length > 0) {
                            devop = Constants.EMPLOYERADMINROLEID;

                        }
                        const headers = { 'Content-Type': 'application/json' }
                        fetch(this.iPAddress + ':/api2/api/getAaroles/' + devop, { headers })
                            .then(async response => {
                                const data = await response.json();

                                if (!response.ok) {

                                    const error = (data && data.message) || response.statusText;
                                    return Promise.reject(error);

                                }

                                this.setState({ Aaroles: data.roleName })
                            })
                            .catch(error => {

                            });

                        fetch(this.iPAddress + '/api2/api/sessionlist?sessionid=' + tokenvalue, { headers })
                            .then(async response => {
                                const data = await response.json();

                                if (!response.ok) {

                                    const error = (data && data.message) || response.statusText;
                                    return Promise.reject(error);

                                }

                                if (data.loginsessionid === null) {
                                    alert("session closed by other login")
                                    window.localStorage.setItem("AUTHDATA", "");
                                    window.localStorage.setItem("selectedCorporateId", "");
                                    window.localStorage.setItem("loggedCorporateId", "");
                                    window.localStorage.setItem("selectedLawfirmId", "");
                                    window.localStorage.setItem("loggedLawfirmId", "");
                                    window.localStorage.setItem("selectedAttorneyId", "");
                                    window.localStorage.setItem("loggedAttorneyId", "");
                                    window.location.href = "/";

                                }
                            })
                            .catch(error => {
                                window.localStorage.setItem("AUTHDATA", "");
                                window.localStorage.setItem("selectedCorporateId", "");
                                window.localStorage.setItem("loggedCorporateId", "");
                                window.localStorage.setItem("selectedLawfirmId", "");
                                window.localStorage.setItem("loggedLawfirmId", "");
                                window.localStorage.setItem("selectedAttorneyId", "");
                                window.localStorage.setItem("loggedAttorneyId", "");
                                window.location.href = "/";

                            });

                        this.setState({ role: role });

                        this.createnewUserMenu();


                    }

                } else {
                    this.setState({ isLogged: false });

                }
                this.setState({ isloading: false });

                if (window.location.href.includes("Email")) {
                    window.location.href = "/vCareDashboard";
                }
            } else if (window.localStorage.getItem("FIRSTLOGIN") === "Yes" && window.location.pathname !== "/firstLoginChangePassword") {
                window.location.href = "/firstLoginChangePassword";
            }
            else {

                if (window.location.pathname !== '/' && !window.location.pathname.includes('/forgotPasswordUpdate') && window.location.pathname !== '/checkingpage' && window.location.pathname !== '/stripePaymentCheckout'
                    && window.location.pathname !== '/vitalzoomsProfileFacility' && window.location.pathname !== '/vitalzoomsInsurancecompanies'
                    && window.location.pathname !== '/vitalzoomsInsurancepractice' && window.location.pathname !== '/vitalzoomsAddPatient'
                    && window.location.pathname !== '/vitalzoomsDashboard' && window.location.pathname !== '/vitalzoomsDischargePlan'
                    && window.location.pathname !== '/vitalzoomsTreatmentPlan' && window.location.pathname !== '/passwordchange' && window.location.pathname !== '/uscis'
                    && window.location.pathname !== '/forgotusername' && window.location.pathname !== '/welcome' && window.location.pathname !== '/index.html'
                ) {
                    window.location.href = "/";
                }
            }
        } catch (exception) {
            console.log(exception);
        }

        const onlineHandler = () => {
            this.setState({ isOnline: true });
        }

        const offlineHandler = () => {
            this.setState({ isOnline: false });
        }
        window.addEventListener("online", onlineHandler);
        window.addEventListener("offline", offlineHandler);


        return () => {
            window.removeEventListener("online", onlineHandler);
            window.removeEventListener("offline", offlineHandler);
        };
    }
    sleep(time) {
        return new Promise((resolve) => setTimeout(resolve, time)
        )
    }
    onWrapperClick(event: React.MouseEvent) {
        if (!this.menuClick) {
            this.setState({
                overlayMenuActive: false,
                mobileMenuActive: false
            });
        }

        this.menuClick = false;
    }

    handleInternetCheck() {
        var confirmvalue = window.confirm("Please Check your internet connection.if you want reload the application? ");

        if (confirmvalue) {
            if (window.location.pathname === "/login") {

            } else {
                window.location.pathname = "/login";
            }
        } else { }

    };

    clickChange() {

        window.location.href = "/staticui/setpassword";

    }

    onToggleMenu(event: React.MouseEvent) {
        this.menuClick = true;

        if (this.isDesktop()) {
            if (this.state.layoutMode === "overlay") {
                this.setState({
                    overlayMenuActive: !this.state.overlayMenuActive
                });
            } else if (this.state.layoutMode === "static") {
                this.setState({
                    staticMenuInactive: !this.state.staticMenuInactive
                });
            }
        } else {
            const mobileMenuActive = this.state.mobileMenuActive;
            this.setState({
                mobileMenuActive: !mobileMenuActive
            });
        }

        event.preventDefault();
    }

    isDesktop(): boolean {
        return window.innerWidth > 1024;
    }

    onSidebarClick(event: React.MouseEvent) {
        this.menuClick = true;

        setTimeout(() => {
            if (this.layoutMenuScroller) {

                (this.layoutMenuScroller as any)["moveBar"]();

            }
        }, 500);
    }



    onMenuItemClick(event: { originalEvent: SyntheticEvent; item: MenuItem }) {
        if (window.location.pathname === '/vCareLawFirmDashboard') {
            window.location.href = "/vCareLawFirmDashboard";
        }

        if (window.location.pathname === '/visaCareCreateEmployer') {
            const loggedInString1 = localStorage.getItem("AUTHDATA");
            const loggedInData = JSON.parse(loggedInString1 || '{}');

            if (
                loggedInData?.userProfile?.[0]?.roleFkId?.roleName === Constants.VISACAREADMINROLENAME
            ) {
                //  window.location.reload();
            }
        }
    }

    handleTabClose = event => {

    };
    public render() {

        window.addEventListener('beforeunload', this.handleTabClose);
        let wrapperClass = classNames("layout-wrapper", {
            "layout-overlay": this.state.layoutMode === "overlay",
            "layout-static": this.state.layoutMode === "static",
            "layout-static-sidebar-inactive":
                this.state.staticMenuInactive && this.state.layoutMode === "static",
            "layout-overlay-sidebar-active":
                this.state.overlayMenuActive && this.state.layoutMode === "overlay",
            "layout-mobile-sidebar-active": this.state.mobileMenuActive
        });

        let sidebarClassName = classNames("layout-sidebar", {
            "layout-sidebar-dark": this.state.layoutColorMode === "dark"
        });

        if ((window.location.pathname === '/firstLoginChangePassword/' || window.location.pathname === '/firstLoginChangePassword' || window.location.pathname.includes('/firstLoginChangePassword/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });


        }

        if ((window.location.pathname === '/visacareAddPaymentMethod/' || window.location.pathname === '/visacareAddPaymentMethod' || window.location.pathname.includes('/visacareAddPaymentMethod/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });


        }
        if ((window.location.pathname === '/visaCareAddNewI129Cases/' || window.location.pathname === '/visaCareAddNewI129Cases' || window.location.pathname.includes('/visaCareAddNewI129Cases/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });


        }
        if ((window.location.pathname === '/visaCareAddNewI129CasesUpcomming/' || window.location.pathname === '/visaCareAddNewI129CasesUpcomming' || window.location.pathname.includes('/visaCareAddNewI129CasesUpcomming/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });


        }
        if ((window.location.pathname === '/visaCareAddI9/' || window.location.pathname === '/visaCareAddI9' || window.location.pathname.includes('/visaCareAddI9/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });


        }
        if ((window.location.pathname === '/visaCareAddNewI140Cases/' || window.location.pathname === '/visaCareAddNewI140Cases' || window.location.pathname.includes('/visaCareAddNewI140Cases/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });


        }

        if ((window.location.pathname === '/visaCareAddNewI539Cases/' || window.location.pathname === '/visaCareAddNewI539Cases' || window.location.pathname.includes('/visaCareAddNewI539Cases/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });
        }
        if ((window.location.pathname === '/visaCareAddNewI539ACases/' || window.location.pathname === '/visaCareAddNewI539ACases' || window.location.pathname.includes('/visaCareAddNewI539ACases/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });
        }
        if ((window.location.pathname === '/visaCareAddI539Cases/' || window.location.pathname === '/visaCareAddI539Cases' || window.location.pathname.includes('/visaCareAddI539Cases/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });
        }
        if ((window.location.pathname === '/visaCareAddI539ACases/' || window.location.pathname === '/visaCareAddI539ACases' || window.location.pathname.includes('/visaCareAddI539ACases/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });
        }


        if ((window.location.pathname === '/visaCareAddCaseH1BI907/' || window.location.pathname === '/visaCareAddCaseH1BI907' || window.location.pathname.includes('/visaCareAddCaseH1BI907/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });


        }

        if ((window.location.pathname === '/visaCareAddCaseG28/' || window.location.pathname === '/visaCareAddCaseG28' || window.location.pathname.includes('/visaCareAddCaseG28/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });

        }

        if ((window.location.pathname === '/visaCareAddCaseI130/' || window.location.pathname === '/visaCareAddCaseI130' || window.location.pathname.includes('/visaCareAddCaseI130/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });

        }
        if ((window.location.pathname === '/visaCareAddCaseI130A/' || window.location.pathname === '/visaCareAddCaseI130A' || window.location.pathname.includes('/visaCareAddCaseI130A/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });

        }
        if ((window.location.pathname === '/visaCareAddCaseI131/' || window.location.pathname === '/visaCareAddCaseI131' || window.location.pathname.includes('/visaCareAddCaseI131/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });

        }

        if ((window.location.pathname === '/visaCareAddCaseI485/' || window.location.pathname === '/visaCareAddCaseI485' || window.location.pathname.includes('/visaCareAddCaseI485/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });

        }
        if ((window.location.pathname === '/visaCareAddCaseI864/' || window.location.pathname === '/visaCareAddCaseI864' || window.location.pathname.includes('/visaCareAddCaseI864/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });

        }


        if ((window.location.pathname === '/visaCareAddNewI765Cases/' || window.location.pathname === '/visaCareAddNewI765Cases' || window.location.pathname.includes('/visaCareAddNewI765Cases/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });

        }
        if ((window.location.pathname === '/visaCareAddNewI9Cases/' || window.location.pathname === '/visaCareAddNewI9Cases' || window.location.pathname.includes('/visaCareAddNewI9Cases/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });

        }
        if ((window.location.pathname === '/docuSignPageView/' || window.location.pathname === '/docuSignPageView' || window.location.pathname.includes('/docuSignPageView/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });

        }
        if ((window.location.pathname === '/wopiTest/' || window.location.pathname === '/wopiTest' || window.location.pathname.includes('/wopiTest/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });

        }
        if ((window.location.pathname === '/wopiEditTest/' || window.location.pathname === '/wopiEditTest' || window.location.pathname.includes('/wopiEditTest/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });

        }

        if ((window.location.pathname === '/wopiVisaPackage/' || window.location.pathname === '/wopiVisaPackage' || window.location.pathname.includes('/wopiVisaPackage/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });

        } if ((window.location.pathname === '/wopiWithdrawal/' || window.location.pathname === '/wopiWithdrawal' || window.location.pathname.includes('/wopiWithdrawal/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });

        } if ((window.location.pathname === '/wopiPublicAccessFile/' || window.location.pathname === '/wopiPublicAccessFile' || window.location.pathname.includes('/wopiPublicAccessFile/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });

        } if ((window.location.pathname === '/wopiH1BRevocation/' || window.location.pathname === '/wopiH1BRevocation' || window.location.pathname.includes('/wopiH1BRevocation/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });

        }
        if ((window.location.pathname === '/wopiCoveringLetter/' || window.location.pathname === '/wopiCoveringLetter' || window.location.pathname.includes('/wopiCoveringLetter/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });

        }
        if ((window.location.pathname === '/wopiWordOnline/' || window.location.pathname === '/wopiWordOnline' || window.location.pathname.includes('/wopiWordOnline/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });

        }
        if ((window.location.pathname === '/wopiOfferLetter/' || window.location.pathname === '/wopiOfferLetter' || window.location.pathname.includes('/wopiOfferLetter/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });

        }

        if ((window.location.pathname === '/wopiDocumentFile/' || window.location.pathname === '/wopiDocumentFile' || window.location.pathname.includes('/wopiDocumentFile/')) && !this.state.isSkipHeader) {
            this.setState({ isSkipHeader: true });

        }

        //  console.log("this.menu", this.menu)

        return (
            <React.Fragment>
                {/*
        <script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyDAzmb-yIUociOEymczq8w0Tf_YeRCrj7Y&callback=init"
          async defer></script>
    */}

                {this.state.isLogged === false && this.state.isOnline === false ? (
                    <div style={{ textAlign: 'center', color: 'red', position: 'relative', zIndex: 1 }}><h6 style={{ fontWeight: 'bold', margin: '0px' }}>Please Check your internet connection...</h6></div>
                ) : this.state.isLogged === true && this.state.isOnline === false && window.location.pathname !== "/login" ? this.handleInternetCheck() : <></>}
                <Switch>
                    {this.state.isSkipHeader && (
                        <><div className="layout-main">
                            <React.Fragment>
                                <Route path="/firstLoginChangePassword" exact={true} component={props => <FirstLoginChangePassword {...props} />} />

                            </React.Fragment>
                        </div>
                            <div className="layout-main acumen-pdf">
                                <React.Fragment>


                                    <Route path="/visaCareAddNewI129CasesUpcomming/:caseid/:companyAutoId" exact={true} component={props => <AddNewI129Upcomming {...props} />} />

                                    <Route path="/visaCareAddNewI129Cases/:caseid/:companyAutoId" exact={true} component={props => <AddNewI129 {...props} />} />
                                    <Route path="/visaCareAddNewI140Cases/:caseid/:companyAutoId" exact={true} component={props => <AddCaseI140 {...props} />} />
                                    <Route path="/visaCareAddNewI539Cases/:caseid/:id" exact={true} component={props => <AddNewCaseI539 {...props} />} />
                                    <Route path="/visaCareAddNewI539ACases/:caseid/:id" exact={true} component={props => <AddNewCaseI539A {...props} />} />

                                    <Route path="/visaCareAddI539Cases/:caseid/:id" exact={true} component={props => <AddCaseI539 {...props} />} />
                                    <Route path="/visaCareAddI539ACases/:caseid/:id" exact={true} component={props => <AddCaseI539A {...props} />} />



                                    <Route path="/visaCareAddCaseH1BI907/:caseid/:companyAutoId/:attorneyid" exact={true} component={props => <AddCaseH1BI907 {...props} />} />
                                    <Route path="/visaCareAddCaseH1BI907/:caseid/:companyAutoId" exact={true} component={props => <AddCaseH1BI907 {...props} />} />

                                    <Route path="/visaCareAddCaseG28/:caseid/:companyAutoId/:attorneyid/:premiumProcess" exact={true} component={props => <AddCaseG28 {...props} />} />
                                    <Route path="/visaCareAddCaseI130/:caseid/:companyAutoId" exact={true} component={props => <AddCaseI130 {...props} />} />
                                    <Route path="/visaCareAddCaseI130A" exact={true} component={props => <AddCaseI130A {...props} />} />
                                    <Route path="/visaCareAddCaseI130A/:caseid/:companyAutoId" exact={true} component={props => <AddCaseI130A {...props} />} />
                                    <Route path="/visaCareAddCaseI131/:caseid/:companyAutoId" exact={true} component={props => <AddCaseI131 {...props} />} />

                                    <Route path="/visaCareAddCaseI485/:caseid/:companyAutoId" exact={true} component={props => <AddCaseI485 {...props} />} />
                                    <Route path="/visaCareAddCaseI864/:caseid/:companyAutoId" exact={true} component={props => <AddCaseI864 {...props} />} />

                                    <Route path="/visaCareAddNewI765Cases/:caseid/:companyAutoId" exact={true} component={props => <AddNewCaseI765 {...props} />} />
                                    <Route path="/wopiH1BRevocation/:caseid" exact={true} component={props => <WopiH1BRevocation {...props} />} />
                                    <Route path="/wopiPublicAccessFile/:caseid" exact={true} component={props => <WopiPublicAccessFile {...props} />} />
                                    <Route path="/wopiVisaPackage/:caseid" exact={true} component={props => <WopiVisaPackage {...props} />} />
                                    <Route path="/wopiWithdrawal/:caseid" exact={true} component={props => <WopiWithdrawal {...props} />} />
                                    <Route path="/wopiCoveringLetter/:caseid" exact={true} component={props => <WopiCoveringLetter {...props} />} />
                                    <Route path="/wopiWordOnline/:caseid/:fileId" exact={true} component={props => <WopiWordFile {...props} />} />
                                    <Route path="/wopiOfferLetter/:fileId/:fileUserId" exact={true} component={props => <WopiOfferLetter {...props} />} />
                                    <Route path="/wopiTest/:caseid" exact={true} component={props => <WopiTest {...props} />} />
                                    <Route path="/wopiEditTest" exact={true} component={props => <WopiEditTest {...props} />} />
                                    <Route path="/docuSignPageView/:signUrl/:fileUserId/:employmentId" exact={true} component={props => <DocuSignViewPage {...props} />} />
                                    <Route path="/wopiDocumentFile/:fileId" exact={true} component={props => <WopiDocumentFile {...props} />} />

                                    <Route path="/visaCareAddI9/:employmentId/:i9Id/:companyAutoId" exact={true} component={props => <AddCaseI9 {...props} />} />


                                </React.Fragment>
                            </div>
                        </>
                    )}
                    {!this.state.isLogged && (
                        <div className="layout-main">

                            <React.Fragment>
                                <Route path="/" exact={true} component={props => <LoginPage {...props} />} />
                                <Route path="/login" exact={true} component={props => <LoginPage {...props} />} />
                                <Route path="/visaCareAddLawFirm" exact={true} component={props => <AddLawFirm {...props} />} />
                                <Route path="/forgotPasswordUpdate/:actcode" exact={true} component={props => <ForgotPasswordUpdate {...props} />} />
                                <Route path="/resetpassword/:id" exact={true} component={props => <ResetpasswordPage {...props} />} />
                                <Route path="/passwordchange" exact={true} component={props => <PasswordchangePage {...props} />} />
                                <Route path="/forgotusername" exact={true} component={props => <ForgotusernamePage {...props} />} />
                                <Route path="/uscis" exact={true} component={props => <UscisCallback {...props} />} />
                                <Route path="/checkingpage" exact={true} component={props => <CheckingPage {...props} />} />
                            </React.Fragment>
                        </div>
                    )}
                    {this.state.isLogged && (
                        <div className={wrapperClass} onClick={this.onWrapperClick}>
                            {!this.state.iconmenuActive && (
                                <AppTopbar onToggleMenu={this.onToggleMenu} />
                            )}
                            {this.state.iconmenuActive && (
                                <AppTopbar onToggleMenu={this.onToggleMenu} />
                            )}
                            {!this.state.iconmenuActive && (
                                <div className={sidebarClassName} onClick={this.onSidebarClick}>

                                    <ScrollPanel
                                        ref={el => (this.layoutMenuScroller = el)}
                                        style={{ height: "100%", width: '200px', overflowY: 'hidden' }}
                                    >
                                        <div className="layout-sidebar-scroll-content">
                                            <div className="layout-logo">
                                                <div className="layout-profile"></div>

                                                <div>

                                                    <AppMenu
                                                        model={this.menu}
                                                        onMenuItemClick={this.onMenuItemClick}
                                                    />
                                                    {/*
                          <div className="menu_button_container">
                          <img style={{height:'20px',float:'left'}} alt="pi pi-angle-left" src={leftArrow} onClick={this._onpush}/> 
                             <Button
                              icon="pi pi-angle-left"
                              onClick={this._onpush}
                              type="button"
                              className="generateButton"
                              style={{
                                alignItems: 'center',
                                backgroundColor: '#e0e0e0',
                                color: ' #232428',
                                width: '40px',
                                border: 0
                              }}
                            />

                          <Button
                              icon="pi pi-cog"
                              type="button"
                              onClick={this.clickChange}
                              className="generateButton"
                              style={{
                                alignItems: 'center',
                                backgroundColor: '#e0e0e0',
                                color: ' #232428',
                                width: '40px',
                                border: 0
                              }}
                            />
                          </div>*/}
                                                </div>



                                            </div>
                                        </div>
                                    </ScrollPanel>
                                </div>
                            )
                            }
                            {this.state.iconmenuActive && (

                                <div className={sidebarClassName} onClick={this.onSidebarClick} style={{ width: '66px', background: 'white' }}>

                                    <div className="layout-sidebar-scroll-content">
                                        <div className="layout-logo" style={{ height: "100vh" }}>

                                            <div>
                                                <AppnewMenu
                                                    onMenuItemClick={this.onMenuItemClick} model={this.menu} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                            }
                            {!this.state.iconmenuActive && (
                                <div className="layout-main">

                                    {this.breadcrumDetails.length > 0 && <BreadCrumb model={this.breadcrumDetails} home={this.home} />}
                                </div>
                            )}
                            {this.state.iconmenuActive && (
                                <div className="layout-main layout-main-active">
                                    <React.Fragment>

                                        <Route path="/" exact={true} component={VisaCareDashboard} />

                                        <Route path="/user/aapermissions" exact={true} component={Aapermissions} />
                                        <Route path="/user/aaroles" exact={true} component={Aaroles} />
                                        <Route path="/user/aarolespermission" exact={true} component={Aarolespermission} />

                                        <Route path="/staticui/setpassword" exact={true} component={setPassword} />

                                        <Route path="/user/newaarolespermission" exact={true} component={Newaarolespermission} />
                                        <Route path="/adminstaticui/addpermission" exact={true} component={Permission} />
                                        <Route path="/adminstaticui/addrole" exact={true} component={Role} />
                                        <Route path="/rolemapview" exact={true} component={RolePermissionMap} />

                                        <Route path="/vCareAttorneyUser" exact={true} component={AttorneyUserPage} />
                                        <Route path="/vCareAttorneyUser/:companyAutoId" exact={true} component={AttorneyUserPage} />
                                        <Route path="/visaCareAttorneyDashboard" exact={true} component={AttorneyDashboard} />
                                        <Route path="/visaCareAttorneyCaseDetails" exact={true} component={AttorneyCaseDetails} />
                                        <Route path="/visaCareEmployerCaseDetails" exact={true} component={AttorneyCaseDetails} />
                                        <Route path="/visaCareEmployerCaseDetails/:companyId" exact={true} component={AttorneyCaseDetails} />


                                        <Route path="/visaCareAttorneyHelpDeskMyCases" exact={true} component={AttorneyHelpDeskMyCases} />
                                        <Route path="/visacareMyCases" exact={false} component={EmployeeMyCases} />
                                        <Route path="/visaCareNewH1BDetails/:caseid" exact={false} component={H1BEmployeeNewCaseDetails} />
                                        <Route path="/visaCareH4EmployeeNewCaseDetails/:caseid" exact={true} component={H4EmployeeNewCaseDetails} />
                                        <Route path="/visaCareI765NewCaseDetails/:caseid" exact={false} component={I765EmployeeNewCaseDetails} />
                                        <Route path="/visaCareNews" exact={true} component={VisacareNews} />
                                        <Route path="/visaCareAddUpcomingEvents" exact={true} component={AddUpcomingEvents} />
                                        <Route path="/visaCareVisaBuiltin" exact={true} component={VisaBulletin} />

                                        <Route path="/visaCareAddLawFirm" exact={true} component={AddLawFirm} />
                                        <Route path="/lawFirmAdd" exact={true} component={AddLawFirm} />
                                        <Route path="/visaCareAddAttorney" exact={true} component={LawFirmAddAttorney} />
                                        <Route path="/visaCareAddAttorney/:lawfirmId" exact={true} component={LawFirmAddAttorney} />
                                        <Route path="/lawFirmAddCorporate" exact={true} component={LawFirmAddCorporate} />
                                        <Route path="/lawFirmAttorneyDashboard" exact={true} component={LawFirmAttorneyDashboard} />
                                        <Route path="/lawFirmAttorneyDashboard/:attorneyId" exact={true} component={LawFirmAttorneyDashboard} />
                                        <Route path="/lawFirmAttorneySetUp" exact={true} component={LawFirmAttorneySetUp} />
                                        <Route path="/visaCareLawFirmAttorneySetUp" exact={true} component={LawFirmAttorneySetUp} />
                                        <Route path="/lawFirmAttorneySetUp/:attorneyId" exact={true} component={LawFirmAttorneySetUp} />
                                        <Route path="/lawFirmCorporateSetup/:id" exact={true} component={LawFirmCorporateSetup} />
                                        <Route path="/lawFirmCorporateSetup" exact={true} component={LawFirmCorporateSetup} />
                                        <Route path="/vCareLawFirmDashboard" exact={true} component={LawFirmDashboard} />
                                        <Route path="/lawFirmDashboard" exact={true} component={LawFirmDashboard} />
                                        <Route path="/lawFirmDashboard/:lawfirmId" exact={true} component={LawFirmDashboard} />
                                        <Route path="/lawFirmFullCalendarTask" exact={true} component={LawFirmFullCalendarTask} />
                                        <Route path="/lawFirmCompanyUserCasePermission" exact={true} component={LawFirmCompanyUserCasePermission} />


                                        <Route path="/lawFirmvisaCareAddNewI129Cases/:caseid" exact={false} component={LawFirmH1BAddCaseI129} />
                                        <Route path="/lawFirmvisaCareH1BCaseDetails/:caseid" exact={false} component={LawFirmH1BCaseDetails} />
                                        <Route path="/lawFirmvisaCareH1BQuestionnaier/:caseid" exact={false} component={LawFirmH1BQuestionnaier} />
                                        <Route path="/lawFirmsDetails" exact={true} component={LawfirmList} />
                                        <Route path="/visaCareManageCorporateCases/:id/:companyId" exact={true} component={LawFirmManageCorporateCases} />
                                        <Route path="/visaCareManageCorporateClient" exact={true} component={LawFirmManageCorporateClient} />
                                        <Route path="/lawFirmManageCorporateClient" exact={true} component={LawFirmManageCorporateClient} />
                                        <Route path="/lawFirmManageCorporateClient/:lawfirmId" exact={true} component={LawFirmManageCorporateClient} />
                                        <Route path="/visaCareManageCorporateUsers/:id" exact={true} component={LawFirmManageCorporateUser} />
                                        <Route path="/vCareLawFirmSetUp" exact={true} component={LawFirmSetUp} />
                                        <Route path="/lawFirmSetUp" exact={true} component={LawFirmSetUp} />
                                        <Route path="/lawFirmSetUp/:lawfirmId" exact={true} component={LawFirmSetUp} />
                                        <Route path="/welcome" exact={true} component={Welcome} />
                                        <Route path="/employeeStatusReports" exact={true} component={EmployeeStatusReports} />
                                        <Route path="/visaCareMailDetails" exact={true} component={SendEmailDetails} />
                                        <Route path="/reportStatus/:companyAutoId" exact={true} component={StatusReport} />
                                        <Route path="/visaCareReportPageView" exact={true} component={ReportPageViewPageView} />
                                        <Route path="/visacareH1BExpirationDateReports/:companyAutoId" exact={true} component={H1BExpirationDateReports} />
                                        <Route path="/visacareCaseStatusReport/:companyAutoId" exact={true} component={CaseStatusReport} />
                                        <Route path="/visacareSearchReportPage/:companyAutoId" exact={true} component={SearchReportPage} />


                                        <Route path="/visacareTrackiingStatusReport/:companyAutoId" exact={true} component={TrackingStatusReport} />
                                        <Route path="/visaCareInvoiceDetails" exact={false} component={InvoiceDetails} />

                                        <Route path="/staticui/permissions" exact={true} component={Permissions} />
                                        <Route path="/staticui/roles" exact={true} component={Roles} />

                                        <Route path="/visaCareStripePaymentMethod/:companyAutoId" exact={true} component={AddPaymentMethod} />
                                        <Route path="/visaCareSubscription" exact={true} component={Subscription} />
                                        <Route path="/visaCareFrequency" exact={true} component={Frequency} />
                                        <Route path="/visaCareSubscriptionFrequencyEmployerView" exact={true} component={SubscriptionFrequencyEmployerView} />
                                        <Route path="/visaCareSubscriptionFrequencyMap" exact={true} component={SubscriptionFrequencyMap} />
                                        <Route path="/visaCareTermsAndConditions" exact={true} component={TermsAndConditions} />
                                        <Route path="/visaCareTransactionDetails" exact={true} component={TransactionDetails} />

                                        <Route path="/visaCareVmCompanyDiscountMapping" exact={true} component={VmCompanyDiscountMapping} />



                                        <Route path="/user/manageusers" exact={true} component={Users} />
                                        <Route path="/visaCareCreateUser" exact={true} component={CreateUser} />
                                        <Route path="/visaCareCreateUser/:companyAutoId" exact={true} component={CreateUser} />
                                        <Route path="/visaCareCreateUser/:companyAutoId/:roleId" exact={true} component={CreateUser} />

                                        <Route path="/visaCareAddNewAttorney/:companyAutoId" exact={true} component={AddNewAttorney} />
                                        <Route path="/visaCareAddNewAttorney/:companyAutoId/:id" exact={true} component={AddNewAttorney} />
                                        <Route path="/visaCareAddNewAttorney" exact={true} component={AddNewAttorney} />

                                        <Route path="/visaCareAddNewI129HBDataCollection" exact={true} component={AddCaseI129H1BDataCollection} />
                                        <Route path="/visaCareAddNewI129HClassification" exact={true} component={AddCaseI129HClassification} />
                                        <Route path="/visaCareAddCorporate" exact={true} component={AddCorporate} />
                                        <Route path="/visaCareAddNewCorporate" exact={true} component={AddNewCorporate} />
                                        <Route path="/visaCareAddNewCorporate/:companyAutoId" exact={true} component={AddNewCorporate} />
                                        <Route path="/visaCareAddCorporateSetup" exact={true} component={EmployerProfile} />
                                        <Route path="/visaCarePAFFile/:caseid" exact={false} component={AddPAFFile} />
                                        <Route path="/visaCareAttorneySetUp" exact={true} component={AttorneySetUp} />
                                        <Route path="/visaCareCasesRFEStatus" exact={true} component={CasesRFEStatus} />
                                        <Route path="/visaCareCasesRFEStatus/:companyAutoId/:inputValue" exact={true} component={CasesRFEStatus} />
                                        <Route path="/visaCareCompanySubscription" exact={false} component={CompanySubscription} />
                                        <Route path="/visaCareCreateCase" exact={true} component={CreateCase} />
                                        <Route path="/visaCareCreateCase/:id" exact={true} component={CreateCase} />
                                        <Route path="/visaCareCreateEmployer" component={CreateEmployer} />
                                        <Route path="/home" exact={true} component={VisaCareDashboard} />
                                        <Route path="/vCareDashboard/:id" exact={true} component={VisaCareDashboard} />

                                        <Route path="/vCareDashboard" exact={true} component={VisaCareDashboard} />
                                        <Route path="/lawFirmCorporateDashboard/:id" exact={true} component={VisaCareDashboard} />
                                        <Route path="/lawFirmCorporateDashboard" exact={true} component={VisaCareDashboard} />
                                        <Route path="/visaCareE3AustralianDetails/:caseid" exact={false} component={E3AustralianDetails} />
                                        <Route path="/visaCareE3AustralianQuestionnaier/:caseid" exact={false} component={E3AustralianQuestionnaier} />
                                        <Route path="/visaCareEADApplicationDetails/:caseid" exact={false} component={EADApplicationDetails} />
                                        <Route path="/visaCareEADQuestionnaier/:caseid" exact={false} component={EADQuestionnaier} />
                                        <Route path="/visaCareEmploymentInfo/:employmentId/:companyAutoId" exact={false} component={EmploymentInfo} />
                                        <Route path="/visaCareFileUploadView" exact={true} component={FileUploadView} />
                                        <Route path="/visaCareFLCCaseDetails/:caseid/:companyAutoId" exact={false} component={FLCCaseDetails} />
                                        <Route path="/visaCareFLCQuestionnaier/:caseid" exact={false} component={FLCQuestionnaier} />
                                        <Route path="/visaCareH1B1CaseDetails/:caseid" exact={false} component={H1B1CaseDetails} />
                                        <Route path="/visaCareH1B1Questionnaier/:caseid" exact={false} component={H1B1Questionnaier} />
                                        <Route path="/visaCareH1BCaseDetails/:caseid/:companyAutoId" exact={false} component={H1BCaseDetails} />
                                        <Route path="/visaCareH1BQuestionnaier/:caseid/:companyAutoId" exact={false} component={H1BQuestionnaier} />
                                        <Route path="/visaCarePAFCaseDetails/:caseid/:companyAutoId" exact={false} component={PAFCaseDetails} />
                                        <Route path="/visaCareI130ACaseDetails/:caseid/:companyAutoId" exact={false} component={I130ACaseDetails} />
                                        <Route path="/visaCareI130BeneficiaryQuestionnaier/:caseid/:companyAutoId" exact={false} component={I130BeneficiaryQuestionnaire} />
                                        <Route path="/visaCareI130PetitionerQuestionnaier/:caseid/:companyAutoId" exact={false} component={I130PetitionerQusetionnaire} />
                                        <Route path="/visaCareI131PetitionerQuestionnaier/:caseid/:companyAutoId" exact={false} component={I131PetitionerQusetionnaire} />
                                        <Route path="/visaCareI864Questionnaier/:caseid/:companyAutoId" exact={false} component={I864Qusetionnaire} />
                                        <Route path="/visaCareI485Questionnaier/:caseid/:companyAutoId" exact={false} component={I485Qusetionnaire} />


                                        <Route path="/visaCareI130CaseDetails/:caseid/:companyAutoId" exact={false} component={I130CaseDetails} />
                                        <Route path="/visaCareI131CaseDetails/:caseid/:companyAutoId" exact={false} component={I131CaseDetails} />
                                        <Route path="/visaCareI864CaseDetails/:caseid/:companyAutoId" exact={false} component={I864CaseDetails} />
                                        <Route path="/visaCareI485CaseDetails/:caseid/:companyAutoId" exact={false} component={I485CaseDetails} />
                                        <Route path="/visaCareChatAI" exact={false} component={ChatAI} />




                                        <Route path="/visaCareH4CaseDetails/:caseid/:companyAutoId" exact={false} component={H4CaseDetails} />
                                        <Route path="/visaCareH4Questionnaier/:caseid" exact={false} component={H4Questionnaier} />
                                        <Route path="/visaCareI140CaseDetails/:caseid/:companyAutoId" exact={false} component={I140CaseDetails} />
                                        <Route path="/visaCareI140Questionnaier/:caseid/:companyAutoId" exact={false} component={I140Questionnaier} />
                                        <Route path="/visaCareI765CaseDetails/:caseid/:companyAutoId" exact={false} component={I765CaseDetails} />

                                        <Route path="/visaCareManageAttorneys" exact={true} component={VisaCareManageAttorneys} />
                                        <Route path="/visaCareManageCases/:userid/:companyAutoId" exact={false} component={VisaCareManageCases} />
                                        <Route path="/visaCareManageCase" exact={true} component={VisaCareManageCases} />
                                        <Route path="/visaCareManageAttorneyHelpCases" exact={true} component={ManageAttorneyHelpCases} />
                                        <Route path="/visaCareManageOrderCases" exact={true} component={ManageOrderCases} />


                                        <Route path="/visaCareManageClients" exact={true} component={VisaCareManageClients} />
                                        <Route path="/vCareManageUser" exact={true} component={VisaCareManageUsers} />
                                        <Route path="/vCareManageUser/:companyAutoId" exact={true} component={VisaCareManageUsers} />
                                        <Route path="/lawFirmBeneficiaryDetails" exact={true} component={VisaCareManageUsers} />
                                        <Route path="/lawFirmBeneficiaryDetails/:companyAutoId" exact={true} component={VisaCareManageUsers} />
                                        <Route path="/visaCareNewUserCreate" exact={true} component={NewUserCreate} />
                                        <Route path="/visaCareStaticPage" exact={true} component={StaticPage} />
                                        <Route path="/visaCareTNPetitionQuestionnaier/:caseid" exact={false} component={TNPetitionDetails} />
                                        <Route path="/visaCareTNPetitionDetails/:caseid" exact={false} component={TNPetitionQuestionnaier} />
                                        <Route path="/visaFormsUpload" exact={true} component={Upload} />
                                        <Route path="/visacareEmployerList" exact={true} component={VisaCareEmployerList} />


                                        <Route path="/checkingpage" exact={true} component={CheckingPage} />
                                        <Route path="/visaCareNewUser" exact={true} component={NewUser} />
                                        <Route path="/visaCareSessionExpire" exact={true} component={SessionExpire} />

                                        <Route path="/visaCareDocumentCaseDetails/:caseid/:companyAutoId" exact={true} component={DocumentCaseDetails} />
                                        <Route path="/visaCareDocumentH4CaseDetails/:caseid/:companyAutoId" exact={true} component={DocumentH4CaseDetails} />
                                        <Route path="/visaCareDocumentEADCaseDetails/:caseid/:companyAutoId" exact={true} component={DocumentEADCaseDetails} />
                                        <Route path="/visaCareDocumentI140CaseDetails/:caseid/:companyAutoId" exact={true} component={DocumentI140CaseDetails} />
                                        <Route path="/visaCareDocumentI485CaseDetails/:caseid/:companyAutoId" exact={true} component={DocumentI485CaseDetails} />
                                        <Route path="/visaCareDocumentI94CaseDetails/:caseid/:companyAutoId" exact={true} component={DocumentI94CaseDetails} />
                                        <Route path="/visaCareDocumentPermCaseDetails/:caseid/:companyAutoId" exact={true} component={DocumentPermCaseDetails} />
                                        <Route path="/visaCareDocumentLCAPAFCaseDetails/:caseid/:companyAutoId" exact={true} component={DocumentLCAPAFCaseDetails} />


                                        <Route path="/visaCareLcaRequestDetails" exact={true} component={LcaRequestDetails} />
                                        <Route path="/visaCareLcaRequestDetails/:companyAutoId" exact={true} component={LcaRequestDetails} />
                                        <Route path="/visaCareAddLcaRequestDetails/:id/:companyAutoId" exact={true} component={AddLCARequestDetails} />
                                        <Route path="/visaCarePublicAccessFiles" exact={true} component={PublicAccessFiles} />
                                        <Route path="/visaCarePublicAccessFiles/:companyAutoId" exact={true} component={PublicAccessFiles} />

                                        <Route path="/visaCareCreatei9/:employmentId/:companyAutoId" exact={true} component={Createi9} />
                                        <Route path="/visaCarei9SearchDetails/:employmentId/:companyAutoId" exact={true} component={I9SearchDetails} />
                                        <Route path="/visaCareI9Dashboard" exact={true} component={I9Dashbord} />
                                        <Route path="/visaCareAddI9Section1/:employmentId/:id/:companyAutoId" exact={true} component={AddI9Section1} />
                                        <Route path="/visaCarePermCaseDetails/:caseid/:companyAutoId" exact={false} component={PermCaseData} />

                                        <Route path="/visaCareAddI9Section1/:employmentId/:companyAutoId" exact={true} component={AddI9Section1} />
                                        <Route path="/chatWithAi" exact={true} component={ChatWithAi} />

                                        <Route path="/emailPage" exact={true} component={EmailPages} />

                                        <Route
                                            path="/visaCareCaseTest"
                                            exact={true}
                                            component={DeleteCaseData}
                                        />
                                        <Route
                                            path="/visaCareCaseTestNew"
                                            exact={true}
                                            component={DeleteCaseDatanew}
                                        />


                                    </React.Fragment>
                                </div>
                            )}
                            <Dialog visible={this.state.addOpenDialog} showHeader={false} modal={true} onHide={() => this.setState({
                                addOpenDialog: false
                            })}>
                                {
                                    this.state.addOpenDialog &&
                                    (
                                        <div id="removePadding">

                                            <p className="dialogSign" style={{ fontSize: '15px' }}>
                                                Are you sure to Logout?
                                            </p>
                                            <p>
                                                <button onClick={this.handleLogout} className="dialogSubmit" >
                                                    Yes
                                                </button>
                                                <button onClick={this.handleClose} className="dialogSubmit">
                                                    No
                                                </button>
                                            </p>
                                        </div>
                                    )
                                }
                            </Dialog>
                        </div>
                    )}
                </Switch>
                <ToastContainer theme="dark" autoClose={1000} />
            </React.Fragment>
        );
    }
}
const ChildApp = withRouter(NewApp as any);
export default ChildApp;